import { Reveal } from "@/lib/motion";
import { IMAGES } from "@/data/site";

export const Vision = () => (
  <section id="vision" data-testid="vision-section" className="relative py-28 sm:py-40 overflow-hidden">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <span className="text-xs uppercase tracking-[0.25em] text-cyan-300/80">
              03 — Our Vision
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-500 leading-[1.12] tracking-[-0.02em] text-white">
              Making powerful technology{" "}
              <span className="text-gradient">accessible</span> to everyone with
              an idea.
            </h2>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-8 text-base sm:text-lg leading-relaxed text-white/55 font-light">
              Our mission is to use artificial intelligence to reduce the
              complexity of building software and launching digital products.
              We believe the ability to create technology should not be limited
              to those who can write code, it should belong to anyone with the
              vision to build something meaningful.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.1}>
          <div className="relative aspect-square max-w-lg mx-auto">
            <img
              src={IMAGES.ecosystemOrb}
              alt=""
              aria-hidden="true"
              className="h-full w-full object-cover orb-breathe"
              style={{
                mixBlendMode: "screen",
                maskImage: "radial-gradient(closest-side, rgba(0,0,0,1) 55%, rgba(0,0,0,0.5) 78%, transparent 98%)",
                WebkitMaskImage: "radial-gradient(closest-side, rgba(0,0,0,1) 55%, rgba(0,0,0,0.5) 78%, transparent 98%)",
              }}
            />
            <div className="pointer-events-none absolute inset-0 glow-cyan glow-breathe scale-75" />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
